import { z } from 'zod';

// TechLogAttachment schema
export const ZTechLogAttachment = z.object({
  id: z.string().describe('Unique identifier for the attachment'),
  contentType: z
    .string()
    .describe(
      'MIME type of the attachment (e.g., application/pdf, image/jpeg)',
    ),
  size: z.number().describe('Size of the attachment in bytes'),
  name: z.string().describe('Original filename of the attachment'),
});

export type ZTechLogAttachmentType = z.infer<typeof ZTechLogAttachment>;
